export default function getSaga() {
  return [];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/reducers/static/states/sagas/authAccountBalanceSaga.js